module.exports = "/_next/static/images/a13190c72d9fc477fc6be4ed3df37c93-instant-pay-xs.png";